import { Colors, Lightning } from '@lightningjs/sdk';
import TextLabel from 'components/common/TextLabel';
import { ttsTagRemoval } from 'support/generalUtils';
import { translate } from 'support/translate';

export interface EmptySearchResultsTemplateSpec
  extends Lightning.Component.TemplateSpec {
  search: string;

  PreTitle: typeof TextLabel;
  Title: typeof TextLabel;
  Description: typeof TextLabel;
}

const DEFAULT_WIDTH = 533;
const FONT_SIZE = 28;
const LINE_HEIGHT = 37;
const DESCRIPTION_MARGIN_TOP = 28;

export default class EmptySearchResults
  extends Lightning.Component<EmptySearchResultsTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<EmptySearchResultsTemplateSpec>
{
  private _PreTitle = this.getByRef('PreTitle')!;
  private _Title = this.getByRef('Title')!;
  private _Description = this.getByRef('Description')!;

  set search(search: string) {
    const text = `"<b>${search}</b>"`;
    this._Title.patch({ text: { text } });
  }

  static override _template(): Lightning.Component.Template<EmptySearchResultsTemplateSpec> {
    const TEXT_SETTINGS: Lightning.textures.TextTexture.Settings = {
      fontSize: FONT_SIZE,
      lineHeight: LINE_HEIGHT,
      textColor: Colors('text').alpha(0.6).get(),
    };

    return {
      w: DEFAULT_WIDTH,
      flex: {
        direction: 'column',
      },
      PreTitle: {
        type: TextLabel,
        text: {
          text: translate('search.emptyResultsTitle'),
          ...TEXT_SETTINGS,
        },
      },
      Title: {
        type: TextLabel,
        flexItem: {
          alignSelf: 'center',
        },
        text: {
          advancedRenderer: true,
          ...TEXT_SETTINGS,
        },
      },
      Description: {
        type: TextLabel,
        flexItem: { marginTop: DESCRIPTION_MARGIN_TOP },
        text: {
          text: translate('search.emptyResultsDescription'),
          ...TEXT_SETTINGS,
        },
      },
    };
  }

  fireAnnounce() {
    const announcement = `${this._PreTitle.text?.text} ${this._Title.text?.text}. ${this._Description.text?.text}`;
    this.fireAncestors('$announce', ttsTagRemoval(announcement), {
      append: true,
    });
  }
}
